import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { BellIcon, SearchIcon, UserIcon, LogOutIcon, SettingsIcon } from 'lucide-react';
const AdminHeader: React.FC = () => {
  const {
    admin,
    logout
  } = useAdminAuth();
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  // Handle clicks outside of profile dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (profileRef.current && !profileRef.current.contains(event.target as Node)) {
        setIsProfileOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };
  return <header className="bg-white shadow-sm z-10" data-id="element-102">
      <div className="px-4 sm:px-6 lg:px-8 py-4" data-id="element-103">
        <div className="flex items-center justify-between" data-id="element-104">
          <h1 className="text-xl font-semibold text-gray-900" data-id="element-105">
            Edo State Services Admin Portal
          </h1>
          <div className="flex items-center space-x-4" data-id="element-106">
            <div className="relative" data-id="element-107">
              <input type="text" placeholder="Search..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-108" />
              <SearchIcon size={20} className="absolute left-3 top-2.5 text-gray-400" data-id="element-109" />
            </div>
            <button className="relative p-2 text-gray-500 hover:text-gray-700 focus:outline-none" data-id="element-110">
              <BellIcon size={20} data-id="element-111" />
              <span className="absolute top-0 right-0 h-4 w-4 bg-red-500 rounded-full text-xs text-white flex items-center justify-center" data-id="element-112">
                2
              </span>
            </button>
            <div className="relative" ref={profileRef} data-id="element-113">
              <button onClick={() => setIsProfileOpen(!isProfileOpen)} className="flex items-center focus:outline-none" aria-expanded={isProfileOpen} aria-haspopup="true" data-id="element-114">
                <div className="h-8 w-8 rounded-full bg-green-600 flex items-center justify-center text-white font-medium mr-2" data-id="element-115">
                  {admin?.name.charAt(0) || 'A'}
                </div>
                <span className="text-sm font-medium text-gray-700 hidden md:inline-block" data-id="element-116">
                  {admin?.name || 'Admin'}
                </span>
              </button>
              {isProfileOpen && <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200" data-id="element-117">
                  <div className="px-4 py-2 border-b border-gray-100" data-id="element-118">
                    <p className="text-sm font-medium text-gray-900" data-id="element-119">
                      {admin?.name}
                    </p>
                    <p className="text-xs text-gray-500 truncate" data-id="element-120">
                      {admin?.email}
                    </p>
                  </div>
                  <a href="/admin/profile" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => setIsProfileOpen(false)} data-id="element-121">
                    <UserIcon size={16} className="mr-3 text-gray-500" data-id="element-122" />
                    Profile
                  </a>
                  <a href="/admin/settings" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => setIsProfileOpen(false)} data-id="element-123">
                    <SettingsIcon size={16} className="mr-3 text-gray-500" data-id="element-124" />
                    Settings
                  </a>
                  <div className="border-t border-gray-100 mt-1" data-id="element-125"></div>
                  <button onClick={handleLogout} className="flex w-full items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50" data-id="element-126">
                    <LogOutIcon size={16} className="mr-3 text-red-500" data-id="element-127" />
                    Logout
                  </button>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default AdminHeader;